export enum LOYALTY_PROGRAM_FIELDS {
	ID = "id",
	NAME = "name",
	ME = "me",
	CAN_SET_REF_CODE = "canSetRefCode",
	CREATED_AT = "createdAt",
	MINIMUM_SPEND = "minimumSpend",
	CASHBACK_PERCENTAGE = "cashbackPercentage",
	MAX_PAYMENT_PERCENTAGE = "maxPaymentPercentage",
	BONUS_COUNT = "bonusCount",
	PURCHASE_AMOUNT = "purchaseAmount",
	NEED_SPEND = "needSpend",
	NEXT_EXPIRED = "nextExpired",
	EXPIRED_AT = "expiredAt",
	EXPIRED_AT_FORMATTED = "expiredAtFormatted",
	CURRENT = "current",
	NEXT = "next",
	AFFILIATE = "affiliate",
	CONTEXT = "context",
	EVENTS = "events",
	REFERRAL = "referral",

	FIRSTNAME = "firstname",
	SURNAME = "surname",
	PATRONYMIC = "patronymic",
	EMAIL = "email",
	MORE_INFO = "moreInfo",
	STATUS = "status",
	DATE = "date",
	DATE_FORMATTED = "dateFormatted",

	TRANSACTION_ID = "transactionId",
	AMOUNT = "amount",
	TYPE = "type",
	DESCRIPTION = "description",
	CONTEXT_TYPE = "type",
	CONTEXT_DESCRIPTION = "description",
	CONTEXT_ID = "id",
	AUTHOR = "author",
	REF_CODE = "refCode",

	PURCHASE = "purchase",
	PRICE = "price",
	CASHBACK = "cashback",
	FILTER_TYPE_TRANSACTION = "filter[type]",
}
